import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class BulkEditInvoiceModel extends BaseModel {
  miscellaneous_items = [];

  static TRANSLATABLE_FIELDS = [];

  rules = {}
  attributeLabels = {}
  attributeHints = {}

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
